import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex dialog-content flex-column xl:flex-row xl:align-items-stretch gutter-s3 flex-grow-1 align-items-stretch" }
const _hoisted_2 = { class: "flex flex-column xl:w-25rem" }
const _hoisted_3 = { class: "panel-outlined mt-s2" }
const _hoisted_4 = { class: "flex mt-s2 align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex align-items-center justify-content-between mt-s2"
}
const _hoisted_6 = { class: "flex text-sm text-muted align-items-center" }
const _hoisted_7 = { class: "flex my-s3 flex-grow-1 flex-column" }
const _hoisted_8 = { class: "mb-s3" }
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = { class: "relative flex-grow-1" }

import { Token } from '@/sdk/entities/token';
import { MODULE_NAMES } from '@/store';
import { PORTFOLIO_ACTION_TYPES } from '@/store/modules/portfolios/portfolios.module';
import { Portfolio } from '@/sdk/entities/portfolio';
import { SettingsForm } from '@/views/pages/liquidity/portfolios/portfolio/models/settings-form';
import { useStore } from 'vuex';
import BlockTitle from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/BlockTitle.vue';
import ChosenTokens from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/ChosenTokens.vue';
import DialogButtons from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/common/DialogButtons.vue';
import { useI18n } from 'vue-i18n';
import CrossChainNetworkListDropdown from '@/components/CrossChainNetworkListDropdown.vue';
import { computed } from 'vue';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { PortfolioSource } from '@/sdk/entities/PortfolioSource';
import { ChainId } from '@/sdk/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogContent',
  props: {
    action: null,
    portfolio: null,
    chosenTokens: null,
    defaultChainId: null,
    noticeType: null,
    isNoticeLoading: { type: Boolean },
    isInputActive: { type: Boolean },
    forceDisabled: { type: Boolean }
  },
  emits: ["cancel", "submit", "changeNetwork"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'submit'): void;
  (e: 'changeNetwork', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  action: 'addLiquidity' | 'withdraw';
  portfolio: Portfolio;
  chosenTokens: Token[];
  defaultChainId?: ChainId;
  noticeType?: string;
  isNoticeLoading: boolean;
  isInputActive: boolean;
  forceDisabled: boolean;
}

const { t } = useI18n();
const { dispatch, state } = useStore();





const getStepTitle = step => t(`portfolio.${props.action}.${step}`);

const onApplySettings = (settings: SettingsForm) => {
  const actionName =
    props.action === 'addLiquidity'
      ? PORTFOLIO_ACTION_TYPES.SET_DEPOSIT_SETTINGS
      : PORTFOLIO_ACTION_TYPES.SET_WITHDRAW_SETTINGS;

  dispatch(MODULE_NAMES.PORTFOLIOS + '/' + actionName, { settings });
};
const isCrossChainPortfolio = computed(
  () => props.portfolio.type === PortfolioSource.PORTFOLIO_CROSSCHAIN,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex-shrink-0 panel-step", { 'panel-step-active': __props.isInputActive }])
      }, [
        _createVNode(BlockTitle, {
          number: "1",
          title: getStepTitle('enterTheAmount'),
          class: "mb-s1",
          "is-active": __props.isInputActive
        }, null, 8, ["title", "is-active"]),
        _renderSlot(_ctx.$slots, "toggleSwitch"),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "inputBlock")
        ]),
        _createElementVNode("div", _hoisted_4, [
          (__props.chosenTokens)
            ? (_openBlock(), _createBlock(ChosenTokens, {
                key: 0,
                action: __props.action,
                tokens: __props.chosenTokens
              }, null, 8, ["action", "tokens"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(isCrossChainPortfolio))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(_unref(t)(`portfolio.easyModeTranslations.${__props.action}.sendTokensTo.caption`)) + " ", 1),
                _createVNode(TooltipIcon, {
                  tooltip: _unref(t)(`portfolio.easyModeTranslations.${__props.action}.sendTokensTo.tooltip`)
                }, null, 8, ["tooltip"])
              ]),
              (_unref(isCrossChainPortfolio))
                ? (_openBlock(), _createBlock(CrossChainNetworkListDropdown, {
                    key: 0,
                    "default-chain-id": __props.defaultChainId ?? __props.portfolio.chainId,
                    "button-text": "",
                    onOnChange: _cache[0] || (_cache[0] = ($event: any) => (emits('changeNetwork', $event)))
                  }, null, 8, ["default-chain-id"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "destinationAddress")
      ], 2),
      (_unref(state).layout.isDesktop)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "notice")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "lossInfo")
            ]),
            _createElementVNode("div", null, [
              _createVNode(DialogButtons, {
                action: __props.action,
                onApplySettings: onApplySettings,
                onCancel: _cache[1] || (_cache[1] = ($event: any) => (emits('cancel'))),
                onSubmit: _cache[2] || (_cache[2] = ($event: any) => (emits('submit')))
              }, null, 8, ["action"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: _normalizeClass(["h-full panel-step", { 'panel-step-active': !__props.isInputActive && !__props.forceDisabled }])
      }, [
        _createVNode(BlockTitle, {
          number: "2",
          title: getStepTitle('dragTokens'),
          disabled: __props.forceDisabled,
          "is-active": !__props.isInputActive && !__props.forceDisabled
        }, null, 8, ["title", "disabled", "is-active"]),
        _renderSlot(_ctx.$slots, "tokenList")
      ], 2)
    ]),
    (!_unref(state).layout.isDesktop)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "notice")
          ]),
          _createElementVNode("div", null, [
            _renderSlot(_ctx.$slots, "lossInfo")
          ]),
          _createElementVNode("div", null, [
            _createVNode(DialogButtons, {
              action: __props.action,
              onApplySettings: onApplySettings,
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (emits('cancel'))),
              onSubmit: _cache[4] || (_cache[4] = ($event: any) => (emits('submit')))
            }, null, 8, ["action"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})